const getFileName = (headers) => {
  const contentDisposition = headers['content-disposition'];
  const start = contentDisposition.indexOf('filename=') + 'filename='.length;
  const end = contentDisposition.indexOf(';', start);
  return contentDisposition.slice(start, end).replaceAll('"', '');
};

export default getFileName;
